import { useContext, useState, Fragment } from "react";
import SignaturePad from "../UI/SignaturePad";
import { requestPartnerAPI } from "../../api/server";
import { AuthContext } from "../../context/auth-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import { uploadBase64String } from "../../util/uploadBase64String";
import PartnerAgreement from "./PartnerAgreement";
import { BiDownload } from "react-icons/bi";
import AgreementPDF from "../../assets/files/partner-agreement.pdf";
import { MdDownload } from "react-icons/md";
import Heading from "../UI/Heading";

export default function Agreement({ completeSetup }) {
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const submitHandler = async (signature) => {
    try {
      setLoading(true);
      const url = await uploadBase64String(
        `partners/${user.uid}/signature`,
        signature
      );
      const response = await requestPartnerAPI("generate-agreement", {
        signature: url,
      });
      setLoading(false);
      completeSetup();
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <div className="grid content-start gap-4">
      <Heading title="FAP Agreement" description="Please scroll down to sign and submit the fleet acquisition partner agreement.">
        <a
          href={AgreementPDF}
          download="partner-agreement-template.pdf"
          target="blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 btn-secondary"
        >
          <p className="hidden text-sm text-stone-200 md:block">
            Download Template
          </p>
          <MdDownload className="text-xl text-stone-200" />
        </a>
      </Heading>
      
      <div className="grid gap-6 h-[520px] overflow-scroll">
        <PartnerAgreement />
        <hr className="hr" />
        {loading ? (
          <LoadingSpinner />
        ) : (
          <SignaturePad setSignature={submitHandler} />
        )}
      </div>
    </div>
  );
}
